import { AiFillQuestionCircle } from 'react-icons/ai';
import { GoAlert } from 'react-icons/go';
import { MdNewReleases, MdInfo, MdCheckCircle } from 'react-icons/md';
import { PaletteVariantsEnum } from "../../../lss";
/**
 * Helper that takes a palette and returns the corresponding icon
 */
export var getCardPaletteIcon = function (palette) {
    var _a;
    var paletteMap = (_a = {},
        _a[PaletteVariantsEnum.PRIMARY] = MdInfo,
        _a[PaletteVariantsEnum.SECONDARY] = AiFillQuestionCircle,
        _a[PaletteVariantsEnum.SUCCESS] = MdCheckCircle,
        _a[PaletteVariantsEnum.WARNING] = GoAlert,
        _a[PaletteVariantsEnum.DANGER] = MdNewReleases,
        _a);
    return paletteMap[palette] || MdInfo;
};
//# sourceMappingURL=getCardPaletteIcon.js.map